import React from 'react';
import Hero from './Hero';
import Features from './Features';
import Science from './Science';
import FAQ from './FAQ';
import Footer from './Footer';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Hero />
      <Features />
      <Science />
      <FAQ />
      <Footer />
    </div>
  );
};

export default LandingPage;